import React, { useState } from 'react';
import ZoneForm from './ZoneForm';
import { ZoneFormValue, IZoneForm } from '../../models/Phase3/Zone';

export default function AlarmPage() {
	const [record, setRecord] = useState<IZoneForm>(new ZoneFormValue());
	const [zone, setZone] = useState<number[]|undefined>();
	return (
		<div className="pageParentDiv">
			<ZoneForm record={record} setRecord={setRecord} setZone={setZone} />
			<div>{zone}</div>
		</div>
	)
}
